export function sortDialoguesBySpeakerAndEmotion(dialogueArray) {
  if (!Array.isArray(dialogueArray)) return [];
  return dialogueArray.slice().sort((a, b) => {
    // Use empty string as a fallback if speaker or emotion is missing
    const speakerA = a.speaker || "";
    const speakerB = b.speaker || "";
    const speakerComparison = speakerA.localeCompare(speakerB);
    if (speakerComparison !== 0) return speakerComparison;

    const emotionA = a.emotion || "";
    const emotionB = b.emotion || "";
    return emotionA.localeCompare(emotionB);
  });
}

/**
 * For each character in charDataArray, iterates over its variations.
 * For each variation, it searches dialogueArray for a dialogue whose:
 *   - speaker (lowercase) matches charData.character.name, and
 *   - emotion (lowercase) matches the variation's name (or variation value).
 *
 * When a matching dialogue is found, this function creates a new text snippet
 * object with the following structure:
 *
 * {
 *   "createdAt": "2024-11-19T13:54:07.000Z",
 *   "fileName": "amused.txt",
 *   "uuid": "character-uuid-from-charData",
 *   "version": "0",
 *   "s3TextUrl": "",
 *   "content": "some funny text here",
 *   "variation": "amused"
 * }
 *
 * This object is appended to the textSnippets array of the first speechSamples element.
 *
 * @param {Array} charDataArray - Array of character objects.
 * @param {Array} dialogueArray - Array of dialogue objects.
 * @returns {Array} - New array of character objects with updated variations.
 */

// sortedDialogues = [{
//   "type": "dialogue",
//   "content": "Hardly a high priority activity, strategically …",
//   "speaker": "Cambitter Dorelli",
//   "emotion": "neutral",
//   "key": "32"
// },
// {
//   "type": "dialogue",
//   "content": "Another time, perhaps.",
//   "speaker": "Cambitter Dorelli",
//   "emotion": "relieved",
//   "key": "50"
// }]

// charDataArray = [{
//   "character": {
//     "name": "Saucerite",
//     "uuid": "d704316d-b671-4ec6-ad6a-1c11917166a1"
//   },
//   "variations": [
//     {
//       "variation": {
//         "name": "amused",
//         "count": 1,
//         "uuid": "106654ab-c54b-46f7-8d34-7170d9791b40",
//         "variation": "amused",
//         "hasSamples": true
//       },
//       "speechSamples": [
//         {
//           "speechSample": {
//             "textSnippetUuid": "b9d8d6f1-43e7-4e61-99bd-359b55e2777a",
//             "voiceSnippetUuid": "be77228e-329d-4a3c-bb2f-0dde88f991c3",
//             "isSelected": false,
//             "title": "Describe sample",
//             "uuid": "c5189fd1-b137-4e08-b4a2-3f44e3eab055",
//             "enabled": true,
//             "status": "INITIALIZED",
//             "revision": "0"
//           },
//           "textSnippets": [
//             {
//               "createdAt": "2024-11-19T13:54:07.000Z",
//               "fileName": "amused.txt",
//               "uuid": "b9d8d6f1-43e7-4e61-99bd-359b55e2777a",
//               "version": "0",
//               "s3TextUrl": "https:&#x2F;&#x2F;aai-api.s3.us-west-1.amazonaws.com&#x2F;aai-users&#x2F;91355c8b-c056-4861-979c-dc8bb4a1e1bf&#x2F;text-sample-snippets&#x2F;amused.txt",
//               "variation": "amused"
//             }
//           ],
//           "voiceSnippets": [
//             {
//               "createdAt": "2024-11-19T13:54:07.000Z",
//               "fileName": "amused.wav",
//               "s3Url": "https:&#x2F;&#x2F;aai-api.s3.us-west-1.amazonaws.com&#x2F;aai-users&#x2F;91355c8b-c056-4861-979c-dc8bb4a1e1bf&#x2F;voice-clone-snippets&#x2F;amused.wav",
//               "uuid": "be77228e-329d-4a3c-bb2f-0dde88f991c3",
//               "version": "0",
//               "variation": "amused"
//             }
//           ]
//         }
//       ]
//     },
//     {
//       "variation": {
//         "name": "curious",
//         "count": 1,
//         "uuid": "000d7a6e-c1cc-4d37-ac4a-5ad1e6cc17f5",
//         "variation": "curious",
//         "hasSamples": false
//       },
//       "speechSamples": [
//         {
//           "speechSample": {},
//           "textSnippets": [],
//           "voiceSnippets": []
//         }
//       ]
//     },
//     {
//       "variation": {
//         "name": "teasing",
//         "count": 1,
//         "uuid": "5839216e-51ee-47c1-be55-2f0ec7b731de",
//         "variation": "teasing",
//         "hasSamples": false
//       },
//       "speechSamples": [
//         {
//           "speechSample": {},
//           "textSnippets": [],
//           "voiceSnippets": []
//         }
//       ]
//     }
//   ]
// }]



// export function updateCharDataWithDialogues(charDataArray, dialogueArray) {
//   if (!Array.isArray(charDataArray) || !Array.isArray(dialogueArray)) return [];
//   const sortedDialogues = sortDialoguesBySpeakerAndEmotion(
//     dialogueArray
//   );

//   return charDataArray.map((charData, idx) => {
//     const targetSpeaker = (charData.character.name || "").toLowerCase();

//     const updatedVariations = charData.variations.map(variationItem => {
//       // Extract the variation value. Prefer variation.name if available; otherwise use variation.variation.
//       const variationValue = (
//         variationItem.variation.name ||
//         variationItem.variation.variation ||
//         ""
//       ).toLowerCase();

//       // Find the first dialogue that matches the character and variation.
//       const matchingDialogue = sortedDialogues.find((dialogue, index) => {
//         const dialogueSpeaker = (dialogue.speaker || "").toLowerCase();
//         const dialogueEmotion = (dialogue.emotion || "").toLowerCase();
//         let isMatch = dialogueSpeaker === targetSpeaker && dialogueEmotion === variationValue;
//         return isMatch;
//       });

//       let newSpeechSamples = variationItem.speechSamples;
//       if (
//         matchingDialogue &&
//         Array.isArray(variationItem.speechSamples) &&
//         variationItem.speechSamples.length > 0
//       ) {
//         // Construct the new text snippet object.
//         const newTextSnippet = {
//           createdAt: new Date().toISOString(),
//           fileName: `${variationValue}.txt`,
//           uuid: charData.character.uuid,
//           version: "0",
//           s3TextUrl: "",
//           content: matchingDialogue.content,
//           variation: variationValue
//         };

//         // Instead of mutating the existing array, create a new one.
//         const firstSample = variationItem.speechSamples[0];
//         const newTextSnippets = [
//           ...(firstSample.textSnippets || []),
//           newTextSnippet
//         ];
//         const updatedFirstSample = {
//           ...firstSample,
//           textSnippets: newTextSnippets
//         };

//         // Create a new speechSamples array with the updated first sample.
//         newSpeechSamples = [updatedFirstSample, ...variationItem.speechSamples.slice(1)];
//       }
//       if (targetSpeaker === 'cambitter') {
//         return null;
//       }
//       return {
//         ...variationItem,
//         speechSamples: newSpeechSamples
//       };
//     });

//     return {
//       ...charData,
//       variations: updatedVariations
//     };
//   });
// }

export function updateCharDataWithDialogues(charDataArray, dialogueArray) {
  if (!Array.isArray(charDataArray) || !Array.isArray(dialogueArray)) return [];

  // Sort dialogues by speaker and emotion.
  const sortedDialogues = sortDialoguesBySpeakerAndEmotion(dialogueArray);

  return charDataArray
    .map((charData) => {
      // Lowercase targetSpeaker for comparison.
      const targetSpeaker = (charData.character.name || "").toLowerCase();

      // Filter variations: only keep those that have a matching dialogue.
      const filteredVariations = charData.variations.filter((variationItem) => {
        const variationValue = (
          variationItem.variation.name ||
          variationItem.variation.variation ||
          ""
        ).toLowerCase();

        const matchingDialogue = sortedDialogues.find((dialogue) => {
          const dialogueSpeaker = (dialogue.speaker || "").toLowerCase();
          const dialogueEmotion = (dialogue.emotion || "").toLowerCase();
          return dialogueSpeaker === targetSpeaker && dialogueEmotion === variationValue;
        });
        return Boolean(matchingDialogue);
      });

      // Update the remaining variations with the new text snippet
      const updatedVariations = filteredVariations.map((variationItem) => {
        const variationValue = (
          variationItem.variation.name ||
          variationItem.variation.variation ||
          ""
        ).toLowerCase();
        const matchingDialogue = sortedDialogues.find((dialogue) => {
          const dialogueSpeaker = (dialogue.speaker || "").toLowerCase();
          const dialogueEmotion = (dialogue.emotion || "").toLowerCase();
          return dialogueSpeaker === targetSpeaker && dialogueEmotion === variationValue;
        });

        let newSpeechSamples = variationItem.speechSamples;
        if (
          matchingDialogue &&
          Array.isArray(variationItem.speechSamples) &&
          variationItem.speechSamples.length > 0
        ) {
          // Construct a new text snippet object
          const newTextSnippet = {
            createdAt: new Date().toISOString(),
            fileName: `${variationValue}.txt`,
            uuid: charData.character.uuid,
            version: "0",
            s3TextUrl: "",
            content: matchingDialogue.content,
            variation: variationValue,
          };

          // Update the first speech sample with the new text snippet.
          const firstSample = variationItem.speechSamples[0];
          const newTextSnippets = [
            ...(firstSample.textSnippets || []),
            newTextSnippet,
          ];
          const updatedFirstSample = {
            ...firstSample,
            textSnippets: newTextSnippets,
          };

          // Create a new speechSamples array with the updated first sample.
          newSpeechSamples = [updatedFirstSample, ...variationItem.speechSamples.slice(1)];
        }
        return {
          ...variationItem,
          speechSamples: newSpeechSamples,
        };
      });

      // If no variations remain after filtering, omit this character from the result.
      if (updatedVariations.length === 0) {
        return null;
      }

      return {
        ...charData,
        variations: updatedVariations,
      };
    })
    .filter((charData) => charData !== null);
}
